export default __webpack_public_path__ + "static/media/4.820e7d23.mp4";